<template>
  <div class="content-wrapper" :class="{ 'loading-opacity': preloader }">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('Acciones correctivas')"
          :directory="directory"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModal(null)"
          >
            Procesar
          </button>
        </div>
      </div>
    </div>

    <div class="row" v-if="showAdditional">
      <div class="col-12">
        <label><strong>Solicitar evidencia adicional</strong></label>
        <app-input type="radio-buttons" v-model="additional" :list="list" />
        <br /><br />
      </div>
    </div>

    <div class="row" v-if="!inputs.version10">
      <div
        class="col-12 col-md-6"
        v-if="
          additional > 0 || (evalTest && evalTest.third_instance_finding601)
        "
      >
        <div class="form-group" v-if="!evalTest.third_instance_finding601">
          <label>
            Solicitud de Evidencias Adicionales<b class="text-danger ml-2" style="font-size: 18px !important">*</b>
          </label>
          <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            :required="true"
          />
          <!-- <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            :required="true"
            v-if="!inputs.request_additional_evidence_603"
          /> -->
          <!-- <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="
                openTab(inputs, 'request_additional_evidence_603')
              "
              v-if="inputs.request_additional_evidence_603"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="
                openDeleteModal('request_additional_evidence_603')
              "
              v-if="
                inputs.request_additional_evidence_603 &&
                !evalTest.second_instance_finding601
              "
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div> -->
        </div>
      </div>
    </div>

    <div class="row" v-if="showFirstFinding_603">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label v-if="inputs.version10">
            Informe de Cierre de No Conformidades del OEC y para la decisión.<b class="text-danger ml-2" style="font-size: 18px !important">*</b>
          </label>
          <label v-if="!inputs.version10">
            Informe para el cierre de hallazgos y decisión.<b class="text-danger ml-2" style="font-size: 18px !important">*</b>
          </label>
          <app-input
            type="file"
            :label="
              inputs.file_603_first
                ? inputs.file_603_first.name
                : $t('upload_your_file')
            "
            v-model="inputs.file_603_first"
            :required="true"
          />
        </div>
      </div>
    </div>
    <div class="row" v-if="showSecondFinding_603 && !showThirdFinding_603">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label v-if="inputs.version10">
            Informe de Cierre de No Conformidades del OEC y para la decisión.<b class="text-danger ml-2" style="font-size: 18px !important">*</b>
          </label>
          <label v-if="!inputs.version10">
            Informe para el cierre de hallazgos y decisión.<b class="text-danger ml-2" style="font-size: 18px !important">*</b>
          </label>
          <app-input
            type="file"
            :label="
              inputs.file_603_second
                ? inputs.file_603_second.name
                : $t('upload_your_file')
            "
            v-model="inputs.file_603_second"
            :required="true"
          />
        </div>
      </div>
    </div>

    <div class="row" v-if="showThirdFinding_603">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label v-if="inputs.version10">
            Informe de Cierre de No Conformidades del OEC y para la decisión.<b class="text-danger ml-2" style="font-size: 18px !important">*</b>
          </label>
          <label v-if="!inputs.version10">
            Informe para el cierre de hallazgos y decisión.<b class="text-danger ml-2" style="font-size: 18px !important">*</b>
          </label>
          <app-input
            type="file"
            :label="
              inputs.file_603_third
                ? inputs.file_603_third.name
                : $t('upload_your_file')
            "
            v-model="inputs.file_603_third"
            :required="true"
          />
        </div>
      </div>
    </div>

    <div class="row" v-if="showTimeA">
      <div class="col-12">
        <legend>
          <p class="text-primary">Solicitar extensión de tiempo</p>
        </legend>
        <div class="form-group">
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="radio-buttons"
            v-model="inputs.extension_603"
            :list="listb"
          />
        </div>
      </div>
      <div class="col-sm-6" v-if="inputs.extension_603">     
        <div class="form-group">
          <label>Justificación por casos de fuerza mayor o fortuito
            <b class="text-danger ml-2" style="font-size: 18px !important">*</b>
          </label>
      
          <app-input
            type="file"
            :label="
              inputs.extension_time603
                ? inputs.extension_time603.name
                : $t('upload_your_file')
            "
            v-model="inputs.extension_time603"
            :required="true"
          />

            <p class="text-danger" v-if="!inputs.extension_time603">
              No se autorizará prórrogas para la entrega del Plan de Acción, 
              así como las evidencias de implementación, salvo en casos de fuerza mayor o fortuitos amparados por la Ley y normativa vigente aplicable, lo cual debe justificar el OEC por escrito mediante oficio y enviarlo al Director de Área.
            </p>
        </div>     
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <legend>
          <p class="text-primary">Documentos anteriores</p>
        </legend>
      </div>
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 25%"
              >
                USUARIO
              </th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="accApp && accApp.request_signed">
              <td class="align-middle">Solicitud de Acreditación</td>
              <td class="align-middle text-center">
                {{
                  accApp.request_signed.user
                    ? `${accApp.request_signed.user.first_name} ${accApp.request_signed.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ accApp.request_signed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(accApp, 'request_signed')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="accApp.request_signed">
              <td class="align-middle">
                Anexos de la Solicitud de Acreditación
              </td>
              <td class="align-middle text-center">
                {{
                  accApp.user
                    ? `${accApp.user.first_name} ${accApp.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ accApp.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  class="btn btn-success"
                  :href="`/accreditations/applications/${accApp.id}?tab=Anexos`"
                  target="_blank"
                  ><app-icon name="file" /> {{ $t("view") }}</a
                >
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.file_evaluation">
              <td class="align-middle">Propuesta del Equipo Evaluador</td>
              <td class="align-middle text-center">
                {{
                  evalTest.file_evaluation.user
                    ? `${evalTest.file_evaluation.user.first_name} ${evalTest.file_evaluation.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.file_evaluation.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'file_evaluation')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.sampling_plan_file">
              <td class="align-middle">Plan de muestreo</td>
              <td class="align-middle text-center">
                {{
                  evalTest.sampling_plan_file.user
                    ? `${evalTest.sampling_plan_file.user.first_name} ${evalTest.sampling_plan_file.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.sampling_plan_file.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'sampling_plan_file')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.risk_matrix">
              <td class="align-middle">Matríz de riesgo</td>
              <td class="align-middle text-center">
                {{
                  evalTest.risk_matrix.user
                    ? `${evalTest.risk_matrix.user.first_name} ${evalTest.risk_matrix.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.risk_matrix.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'risk_matrix')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.report_documentary_evaluation">
              <td class="align-middle">Informe de Evaluación Documental</td>
              <td class="align-middle text-center">
                {{
                  evalTest.report_documentary_evaluation.user
                    ? `${evalTest.report_documentary_evaluation.user.first_name} ${evalTest.report_documentary_evaluation.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.report_documentary_evaluation.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'report_documentary_evaluation')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.first_instance_finding403">
              <td class="align-middle">
                (Evaluación Documental) Primera entrega - Informe para el cierre
                de hallazgos y decisión
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.first_instance_finding403.user
                    ? `${evalTest.first_instance_finding403.user.first_name} ${evalTest.first_instance_finding403.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.first_instance_finding403.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'first_instance_finding403')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.request_additional_evidence">
              <td class="align-middle">
                (Evaluación Documental) Solicitud de Evidencias Adicionales
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.request_additional_evidence.user
                    ? `${evalTest.request_additional_evidence.user.first_name} ${evalTest.request_additional_evidence.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.request_additional_evidence.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'request_additional_evidence')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.closing_finding_report">
              <td class="align-middle">
                (Evaluación Documental) Informe para el cierre de hallazgos y
                decisión (Evaluador)
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.closing_finding_report.user
                    ? `${evalTest.closing_finding_report.user.first_name} ${evalTest.closing_finding_report.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.closing_finding_report.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'closing_finding_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.second_instance_finding403">
              <td class="align-middle">
                (Evaluación Documental) Segunda entrega - Informe para el cierre
                de hallazgos y decisión
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.second_instance_finding403.user
                    ? `${evalTest.second_instance_finding403.user.first_name} ${evalTest.second_instance_finding403.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.second_instance_finding403.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'second_instance_finding403')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.closing_finding_report_second">
              <td class="align-middle">
                (Evaluación Documental) 2do Informe para el cierre de hallazgos
                y decisión (Evaluador)
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.closing_finding_report_second.user
                    ? `${evalTest.closing_finding_report_second.user.first_name} ${evalTest.closing_finding_report_second.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.closing_finding_report_second.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'closing_finding_report_second')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.evaluation_plan_report">
              <td class="align-middle">
                (Evaluación InSitu / Remota) Plan de Evaluación
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.evaluation_plan_report.user
                    ? `${evalTest.evaluation_plan_report.user.first_name} ${evalTest.evaluation_plan_report.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.evaluation_plan_report.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'evaluation_plan_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <!-- <tr v-if="evalTest && evalTest.accepted_evaluation_plan">
              <td class="align-middle">
                (Evaluación InSitu / Remota) Plan de Evaluación (Aprobado por el
                OEC)
              </td>
              <td class="align-middle text-center">
                {{ evalTest.accepted_evaluation_plan.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'accepted_evaluation_plan')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->
            <tr v-if="evalTest && evalTest.remote_in_situ_assessment_report">
              <td class="align-middle">
                (Evaluación InSitu / Remota) Informe de Evaluación InSitu /
                Remota
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.remote_in_situ_assessment_report.user
                    ? `${evalTest.remote_in_situ_assessment_report.user.first_name} ${evalTest.remote_in_situ_assessment_report.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.remote_in_situ_assessment_report.created_at
                    | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'remote_in_situ_assessment_report')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.testification_report">
              <td class="align-middle">Informe de Testificación</td>
              <td class="align-middle text-center">
                {{
                  evalTest.testification_report.user
                    ? `${evalTest.testification_report.user.first_name} ${evalTest.testification_report.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.testification_report.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'testification_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.other_record506">
              <td class="align-middle">Otro</td>
              <td class="align-middle text-center">
                {{
                  evalTest.other_record506.user
                    ? `${evalTest.other_record506.user.first_name} ${evalTest.other_record506.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.other_record506.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'other_record506')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12" v-if="evalTest.management_system_file && 
        evalTest.management_system_file.length > 0 && evalTest.type == 'E'"
      >
        <legend>
          <p class="text-primary">Documentación del OEC previo a la  
            <span class="title-legend" v-if="evalTest.type == 'E'">evaluación</span>
            <span class="title-legend" v-if="evalTest.type == 'T'">testificación</span>
          </p>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 25%"
              >
                USUARIO
              </th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in evalTest.management_system_file" :key="i">
              <td class="align-middle">
                {{ 
                  v.filename
                  ? `${v.filename}`
                  : `${v.annexed.path.split("/")[v.annexed.path.split("/").length - 1]}`
                }}
              </td>
              <td class="align-middle text-center">
                <span v-if="v.annexed">
                  {{ v.annexed.user.first_name }}
                  {{ v.annexed.user.last_name }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span>{{ v.created_at | dateFormat }}</span>
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(v, 'annexed')"
                  v-if="v.annexed"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-sm-12" v-if="evalTest.testification_certification_aditional && evalTest.testification_certification_aditional.length > 0">
        <legend>
          <p class="text-primary">Documentación del OEC previo a la testificación</p>
        </legend>
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center" style="width: 20%">NOMBRE DEL ARCHIVO</th>
              <th scope="col">CARGADO POR</th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in evalTest.testification_certification_aditional" :key="'e' + i">
              <td class="text-center">
                {{ v.filename }}
              </td>
              <td>{{v.annexed.user.full_name}}</td>
              <td class="text-center">
                {{ v.created_at | dateFormat }}
              </td>
              <td class="text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTabAditional(v.annexed)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12">
        <legend>
          <p class="text-primary">Informe para el cierre de hallazgos OEC</p>
        </legend>
      </div>

      <div class="col-12" v-if="evalTest && evalTest.first_instance_finding601">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 25%"
              >
                USUARIO
              </th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="evalTest && evalTest.first_instance_finding601">
              <td class="align-middle">
                Informe para el cierre de
                hallazgos y decisión <b>OEC</b>
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.first_instance_finding601.user
                    ? `${evalTest.first_instance_finding601.user.first_name} ${evalTest.first_instance_finding601.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.first_instance_finding601.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'first_instance_finding601')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.second_instance_finding601">
              <td class="align-middle">
                Primera entrega - Informe para el cierre de
                hallazgos y decisión <b>OEC</b>
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.second_instance_finding601.user
                    ? `${evalTest.second_instance_finding601.user.first_name} ${evalTest.second_instance_finding601.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.second_instance_finding601.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'second_instance_finding601')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest && evalTest.third_instance_finding601">
              <td class="align-middle">
                Segunda entrega - Informe para el cierre de
                hallazgos y decisión <b>OEC</b>
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.third_instance_finding601.user
                      ? `${evalTest.third_instance_finding601.user.first_name} ${evalTest.third_instance_finding601.user.last_name}`
                      : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.third_instance_finding601.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                    openTab(evalTest, 'third_instance_finding601')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <div
          class="col-12 mt-4"
          v-if="
          evalTest.support_management_non_conformities_601_1 &&
            evalTest.support_management_non_conformities_601_1.length > 0
        ">
        <legend class="text-primary">
          Respaldo informe para el cierre de hallazgos y decisión primera
          entrega
        </legend>
        <table class="table table-sm table-striped mt-2">
          <thead>
          <tr>
            <th scope="col">NOMBRE</th>
            <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(value,
              key) in evalTest.support_management_non_conformities_601_1"
              :key="key"
          >
            <td class="align-middle">
              <small class="text-primary">{{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}</small>
            </td>
            <td class="align-middle text-center">
              <div class="mt-2">
                <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(
                        evalTest.support_management_non_conformities_601_1,
                        key
                      )
                    "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>



        <div
            class="col-12 mt-4"
            v-if="
          evalTest.support_management_non_conformities_601_2 &&
            evalTest.support_management_non_conformities_601_2.length > 0
        "
        >
          <legend class="text-primary">
            Respaldo informe para el cierre de hallazgos y decisión primera
            entrega de evidencia adicional
          </legend>
          <table class="table table-sm table-striped mt-2">
            <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(value,
              key) in evalTest.support_management_non_conformities_601_2"
                :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                    value.path.split("/")[value.path.split("/").length - 1]
                  }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                      openTab(
                        evalTest.support_management_non_conformities_601_2,
                        key
                      )
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div
            class="col-12 mt-4"
            v-if="
          evalTest.support_management_non_conformities_601_3 &&
            evalTest.support_management_non_conformities_601_3.length > 0
        "
        >
          <legend class="text-primary">
            Respaldo informe para el cierre de hallazgos y decisión segunda
            entrega de evidencia adicional
          </legend>
          <table class="table table-sm table-striped mt-2">
            <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(value,
              key) in evalTest.support_management_non_conformities_601_3"
                :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                    value.path.split("/")[value.path.split("/").length - 1]
                  }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                      openTab(
                        evalTest.support_management_non_conformities_601_3,
                        key
                      )
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>






      <div class="col-12" >
        <legend v-if="evalTest && evalTest.findings_closing_report_603_first">
          <p class="text-primary">
            Informe para el cierre de hallazgos evaluador
          </p>
        </legend>
        <div class="row">
          <table class="table table-sm table-striped" v-if="evalTest && evalTest.findings_closing_report_603_first">
            <thead>
              <tr>
                <th scope="col">NOMBRE</th>
                <th
                  scope="col"
                  class="align-middle text-center"
                  style="width: 25%"
                >
                  USUARIO
                </th>
                <th scope="col" class="text-center" style="width: 15%">
                  FECHA DE CREACIÓN
                </th>
                <th scope="col" class="text-center" style="width: 10%">
                  ACCIÓN
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="evalTest && evalTest.findings_closing_report_603_first">
                <td class="align-middle">
                  (No Conformidades) Solicitud de Evidencias Adicionales
                  Evaluador
                </td>
                <td class="align-middle text-center">
                  {{
                    evalTest.findings_closing_report_603_first.user
                      ? `${evalTest.findings_closing_report_603_first.user.first_name} ${evalTest.findings_closing_report_603_first.user.last_name}`
                      : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{
                    evalTest.findings_closing_report_603_first.created_at
                      | dateFormat
                  }}
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(evalTest, 'findings_closing_report_603_first')
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr
                v-if="evalTest && evalTest.findings_closing_report_603_second"
              >
                <td class="align-middle">
                  (No Conformidades) Solicitud de Evidencias Adicionales
                  Evaluador
                </td>
                <td class="align-middle text-center">
                  {{
                    evalTest.findings_closing_report_603_second.user
                      ? `${evalTest.findings_closing_report_603_second.user.first_name} ${evalTest.findings_closing_report_603_second.user.last_name}`
                      : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{
                    evalTest.findings_closing_report_603_second.created_at
                      | dateFormat
                  }}
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(evalTest, 'findings_closing_report_603_second')
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="evalTest && evalTest.findings_closing_report_603_third">
                <td class="align-middle">
                  (No Conformidades) Solicitud de Evidencias Adicionales
                  Evaluador
                </td>
                <td class="align-middle text-center">
                  {{
                    evalTest.findings_closing_report_603_third.user
                      ? `${evalTest.findings_closing_report_603_third.user.first_name} ${evalTest.findings_closing_report_603_third.user.last_name}`
                      : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{
                    evalTest.findings_closing_report_603_third.created_at
                      | dateFormat
                  }}
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(evalTest, 'findings_closing_report_603_third')
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="col-12"
        v-if="
          evalTest.attendance_record && evalTest.attendance_record.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Evaluación InSitu / Remota) Registro de asistencia participación
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, key) in evalTest.attendance_record"
                  :key="key"
                >
                  <td class="align-middle">
                    <!-- {{ value.file_name }} {{ key + 1 }} -->
                    {{
                      value.path.split("/")[value.path.split("/").length - 1]
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(evalTest.attendance_record, key)"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        v-if="
          evalTest.preparation_meeting &&
            evalTest.preparation_meeting.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Evaluación InSitu / Remota) Reunión de preparación de evaluación
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, key) in evalTest.preparation_meeting"
                  :key="key"
                >
                  <td class="align-middle">
                    <!--{{ value.file_name }} {{ key + 1 }}-->
                    {{
                      value.path.split("/")[value.path.split("/").length - 1]
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest.preparation_meeting, key)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        v-if="
          evalTest.evaluation_questionnaire &&
            evalTest.evaluation_questionnaire.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Evaluación InSitu / Remota) Cuestionario de Evaluación Técnicos
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, key) in evalTest.evaluation_questionnaire"
                  :key="key"
                >
                  <td class="align-middle">
                    <!-- {{ value.file_name }} {{ key + 1 }} -->
                    {{
                      value.path.split("/")[value.path.split("/").length - 1]
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest.evaluation_questionnaire, key)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        v-if="
          evalTest.expert_participation_record &&
            evalTest.expert_participation_record.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Evaluación InSitu / Remota) Informe Participación Expertos Técnicos
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, key) in evalTest.expert_participation_record"
                  :key="key"
                >
                  <td class="align-middle">
                    <!-- {{ value.file_name }} {{ key + 1 }} -->
                    {{
                      value.path.split("/")[value.path.split("/").length - 1]
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest.expert_participation_record, key)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
          class="col-12"
          v-if="evalTest.other_file_505 && evalTest.other_file_505.length > 0"
        >
          <legend>
            <p class="text-primary">
              <small
                >(Evaluación InSitu / Remota) Otros archivos cargados</small
              >
            </p>
          </legend>
          <div class="row">
            <div class="col-12">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th scope="col">NOMBRE</th>
                    <th
                      scope="col"
                      class="align-middle text-center"
                      style="width: 25%"
                    >
                      USUARIO
                    </th>
                    <th scope="col" class="text-center" style="width: 15%">
                      FECHA DE CREACIÓN
                    </th>
                    <th scope="col" class="text-center" style="width: 10%">
                      ACCIÓN
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, key) in evalTest.other_file_505" :key="key">
                    <td class="align-middle">
                      {{ value.filename }}
                    </td>
                    <td class="align-middle text-center">
                      {{
                        value.annexed.user
                          ? `${value.annexed.user.first_name} ${value.annexed.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{ value.created_at | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="openTab505(value.annexed.path, key)"
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div
          class="col-12"
          v-if="evalTest.action_plan"
        >
          <legend>
            <p class="text-primary">
                Plan de acción
            </p>
          </legend>
          <div class="row">
            <div class="col-12">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th scope="col">NOMBRE</th>
                    <th
                      scope="col"
                      class="align-middle text-center"
                      style="width: 25%"
                    >
                      USUARIO
                    </th>
                    <th scope="col" class="text-center" style="width: 15%">
                      FECHA DE CREACIÓN
                    </th>
                    <th scope="col" class="text-center" style="width: 10%">
                      ACCIÓN
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="align-middle">
                      Plan de acción
                    </td>
                    <td class="align-middle text-center">
                      {{
                        evalTest.action_plan.user
                          ? `${evalTest.action_plan.user.first_name} ${evalTest.action_plan.user.last_name}`
                          : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{ evalTest.action_plan.created_at | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="openTab505(evalTest.action_plan.path, key)"
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-12" v-if="
          evalTest.observation_plan_action
        ">
          <legend class="text-primary">
            <p>Correciones del plan de acción</p>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="align-middle">
                  Correciones
                </td>
                <td class="align-middle text-center">
                  {{
                      evalTest.observation_plan_action.user
                        ? `${evalTest.observation_plan_action.user.first_name} ${evalTest.observation_plan_action.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ evalTest.observation_plan_action.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(evalTest,'observation_plan_action')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          evalTest.report_plan_action
        ">
          <legend class="text-primary">
            <p>Informe para el cierre de No Conformidades de OEC y para la Decisión</p>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="align-middle">
                  Informe para el cierre de No Conformidades de OEC y para la Decisión
                </td>
                <td class="align-middle text-center">
                  {{
                      evalTest.report_plan_action.user
                        ? `${evalTest.report_plan_action.user.first_name} ${evalTest.report_plan_action.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ evalTest.report_plan_action.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(evalTest,'report_plan_action')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      <div
        class="col-12"
        v-if="
          evalTest.attendance_record_testification &&
            evalTest.attendance_record_testification.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Testificación) Registro de asistencia participación
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value,
                  key) in evalTest.attendance_record_testification"
                  :key="key"
                >
                  <td class="align-middle">
                    {{ value.file_name }} {{ key + 1 }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest.attendance_record_testification, key)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        v-if="
          evalTest.testification_evaluation_questionnaire &&
            evalTest.testification_evaluation_questionnaire.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Testificación) Cuestionario de Testificación Técnicos
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value,
                  key) in evalTest.testification_evaluation_questionnaire"
                  :key="key"
                >
                  <td class="align-middle">
                    {{ value.file_name }} {{ key + 1 }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(
                          evalTest.testification_evaluation_questionnaire,
                          key
                        )
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        v-if="
          evalTest.expert_participation_record_testification &&
            evalTest.expert_participation_record_testification.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Testificación) Informe Participación Expertos Técnicos
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value,
                  key) in evalTest.expert_participation_record_testification"
                  :key="key"
                >
                  <td class="align-middle">
                    {{ value.file_name }} {{ key + 1 }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(
                          evalTest.expert_participation_record_testification,
                          key
                        )
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmedDelete"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../apiUrl";
import { TableHelpers } from "./TableHelpers";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  extends: CoreLibrary,
  name: "corrective-actions-form",
  mixins: [FormMixin, TableHelpers],
  props: {
    evaluationId: String,
  },
  data() {
    return {
      inputs: {
        file_1: null,
        file_603_first: null,
        file_603_second: null,
        file_603_thid: null,
      },
      showThirdFinding_603: false,
      showSecondFinding_603: false,
      showFirstFinding_603: false,
      additional: 0,
      additional2: 0,
      list: [
        {
          id: "0",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
      listb: [
        {
          id: 0,
          value: "No",
        },
        {
          id: 1,
          value: "Si",
        },
      ],
      deleteLoader: false,
      deleteConfirmationModalActive: false,
      deleteModal: false,
      deleteFile: null,
      showTimeA: true,
      preloader: false,
      showAdditional: true,
    };
  },
  computed: {
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },
    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : null;
    },
    directory() {
      return this.evalTest.id
        ? this.evalTest.type == "E"
          ? "Evaluación In Situ/Remota"
          : "Testificación"
        : "";
    },
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": function() {
      this.loadForm();
    },
    "additional": function () {
      this.inputs.file_1 = null;
    },
  },
  filters: {
    dateFormat: function(value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    this.$store.state.evaluatorReview.evalTestId = this.evaluationId;
    this.data();
  },
  methods: {
    returnPage() {
      window.location.href = `${actions.REVIEW_CORRECTIVE_ACTIONS_TECHNICAL}`;
    },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.deleteModal = false;
    },
    confirmedDelete() {
      this.inputs[this.deleteFile] = null;
    },
    confirmed() {
      this.deleteLoader = true;
      const url = `${actions.REVIEW_CORRECTIVE_ACTIONS_TECHNICAL}/store/${this.evaluationId}`;

      let formData = new FormData();
      this.inputs.additional_evidence = this.additional;
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      formData.append("evaluationId", this.evaluationId);

      if (this.inputs.extension_603 == 1) {
        if (!this.inputs.extension_time603) {
          this.$toastr.e("Es necesario cargar los archivos requeridos");
          return;
        }
      } else {
        if (this.additional == 1) {
          if (!this.inputs.version10) {
            if (this.showFirstFinding_603) {
            if (!this.inputs.file_1 || !this.inputs.file_603_first) {
              this.$toastr.e("Es necesario cargar los archivos requeridos");
              return;
            }
          } else if (this.showSecondFinding_603 && !this.showThirdFinding_603) {
            if (!this.inputs.file_1 || !this.inputs.file_603_second) {
              this.$toastr.e("Es necesario cargar los archivos requeridos");
              return;
            }
          } else if (this.showThirdFinding_603) {
            if (!this.inputs.file_1 || !this.inputs.file_603_third) {
              this.$toastr.e("Es necesario cargar los archivos requeridos");
              return;
            }
          }
          }
          if (this.inputs.version10) {
            if (this.showFirstFinding_603) {
            if (!this.inputs.file_603_first) {
              this.$toastr.e("Es necesario cargar los archivos requeridos");
              return;
            }
          } else if (this.showSecondFinding_603 && !this.showThirdFinding_603) {
            if (!this.inputs.file_603_second) {
              this.$toastr.e("Es necesario cargar los archivos requeridos");
              return;
            }
          } else if (this.showThirdFinding_603) {
            if (!this.inputs.file_603_third) {
              this.$toastr.e("Es necesario cargar los archivos requeridos");
              return;
            }
          }
          }
        }
        if (this.additional == 0) {
          if (this.showFirstFinding_603) {
            if (!this.inputs.file_603_first) {
              this.$toastr.e("Es necesario cargar los archivos requeridos");
              return;
            }
          } else if (this.showSecondFinding_603 && !this.showThirdFinding_603) {
            if (!this.inputs.file_603_second) {
              this.$toastr.e("Es necesario cargar los archivos requeridos");
              return;
            }
          } else if (this.showThirdFinding_603) {
            if (!this.inputs.file_603_third) {
              this.$toastr.e("Es necesario cargar los archivos requeridos");
              return;
            }
          }
        }
      }
      this.preloader =  true;
      axios
        .post(url, formData)
        .then(({ data: res }) => {
          $("#modal-confirm-id").modal("hide");
          this.cancelled();
          if (res.status === true) {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.deleteLoader = false;
          this.preloader =  false;
        });
    },
    data() {
      this.$store.dispatch("getEvalTest");
    },
    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    openTab505(obj) {
      const w = window.open(obj, "_blank");
      w.focus();
    },
    openDeleteFile(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },
    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          additional_evidence: this.$store.state.evaluatorReview.evalTest
            .additional_evidence,
          request_additional_evidence_603: this.$store.state.evaluatorReview
            .evalTest.request_additional_evidence_603,
          findings_closing_report_603_first: this.$store.state.evaluatorReview
            .evalTest.findings_closing_report_603_first,
          findings_closing_report_603_second: this.$store.state.evaluatorReview
            .evalTest.findings_closing_report_603_second,
          findings_closing_report_603_thid: this.$store.state.evaluatorReview
            .evalTest.findings_closing_report_603_third,
          file_1: null,
          file_603_first: null,
          file_603_second: null,
          file_603_thid: null,
          extension_603: this.$store.state.evaluatorReview.evalTest.extension_603,
          extension_time603: this.$store.state.evaluatorReview.evalTest.extension_time603,
          version10: this.$store.state.evaluatorReview.evalTest.accreditation_applications.revision_v10 ? 1: 0,
        };
        // this.additional = this.$store.state.evaluatorReview.evalTest.additional_evidence;
        if (this.$store.state.evaluatorReview.evalTest.accreditation_applications.revision_v10) {
            if (this.evalTest.second_instance_finding601) {
                this.showAdditional = false;
            }
            if (this.$store.state.evaluatorReview.evalTest.show_timea_eval) {
            this.showTimeA = false;
          }
        } else {
          if (this.evalTest.third_instance_finding601) {
                this.showAdditional = false;
            }
          this.showTimeA = false;
        }
        if (
          this.$store.state.evaluatorReview.evalTest
            .findings_closing_report_603_first
        ) {
          this.showSecondFinding_603 = true;
        }
        if (
          this.$store.state.evaluatorReview.evalTest
            .findings_closing_report_603_second
        ) {
          this.showThirdFinding_603 = true;
        }
        if (
          !this.$store.state.evaluatorReview.evalTest
            .findings_closing_report_603_first
        ) {
          this.showFirstFinding_603 = true;
        }
      }
    },
  },
};
</script>
<style>
.title-legend {
  font-size: 1em;
}
</style>
